module.exports = __webpack_public_path__ + "img/USDT.f684ccd1.svg";